import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSiteConfig, SiteConfig } from '../services/siteConfigService';
import styles from '../styles/rootLanding.module.css';

export default function RootLanding() {
  const [config, setConfig] = useState<SiteConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    getSiteConfig().then((c) => {
      if (!cancelled) setConfig(c);
    });
    return () => { cancelled = true; };
  }, []);

  const tagline = config?.tagline ?? "Work your steps. Support your recovery. Give your meeting a home page.";
  const sectionHeading = config?.section_heading ?? "What you'll find here";
  const bullet1 = config?.bullet1 ?? "A place to track your 12 step work with guided actions, videos, and progress you own—so you keep your momentum.";
  const bullet2 = config?.bullet2 ?? "A place where your meeting can have a home page: information, service, and group business in one place—where members can join and contribute.";
  const bullet3 = config?.bullet3 ?? "Privacy and control: Your step work is encrypted and only you see it; you and your meeting control who sees meeting information.";

  return (
    <div className={styles.container}>
      <div className={styles.logoRow}>
        <img
          src="/recovery_commons_icon.png"
          alt="Recovery Commons"
          className={styles.logo}
        />
      </div>
      <h1 className={styles.title}>Recovery Commons</h1>
      <p className={styles.tagline}>{tagline}</p>

      <section className={styles.whatIs}>
        <h2 className={styles.whatIsTitle}>{sectionHeading}</h2>
        <ul className={styles.bullets}>
          <li>{bullet1}</li>
          <li>{bullet2}</li>
          <li>{bullet3}</li>
        </ul>
      </section>

      <Link to="/saa" className={styles.programCard}>
        <span className={styles.programName}>SAA</span>
        <span className={styles.programSubtitle}>Sex Addicts Anonymous</span>
      </Link>
      <p className={styles.comingSoon}>More programs (e.g. AA) coming later.</p>
    </div>
  );
}
